import { ErrorPage as Error } from "./errorPage.page";
export default Error;
